import ApiService from '../common/api.service';

import {
  FETCH_ACCESOS,
  CLEAR_ACCESOS_ACTION,
  FETCH_FRONT_IMAGE,
  FETCH_SIDE_IMAGE,
  FETCH_BACK_IMAGE,
  FETCH_FACE_IMAGE,
  FETCH_CREDENTIAL_IMAGE, FETCH_BACK_CREDENTIAL_IMAGE,
} from './actions.type';

import {
  SET_ACCESOS,
  CLEAR_ACCESOS,
  SET_ERROR,
  FETCHING_ACCESOS,
  FETCHED_ACCESOS,
  SET_ACCESO_DETALLES,
  CLEAR_ACCESOS_DETALLES,
  FETCHING_ACCESO_DETALLES,
  FETCHED_ACCESO_DETALLES,
  CLEAR_IMAGES,
  SET_FRONT_IMAGE,
  SET_BACK_IMAGE,
  SET_SIDE_IMAGE,
  SET_FACE_IMAGE, SET_CREDENTIAL_IMAGE, SET_BACK_CREDENTIAL_IMAGE,
} from './mutations.type';


/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  accesos_list: [],
  loading_accesos: false,
  getted_detalles: false,
  sending_revoke: false,
  revoke_sent: false,
  alert: false,
  alertMessage: '',
  alertType: 'success',
  accesos_detalles: [],
  accesos_total: 0,
  frontImage: null,
  sideImage: null,
  backImage: null,
  faceImage: null,
  credentialImage: null,
  backCredentialImage: null,
};

const getters = {
  faceImage(state) {
    return state.faceImage;
  },
  credentialImage(state) {
    return state.credentialImage;
  },
  backCredentialImage(state) {
    return state.backCredentialImage;
  },
  frontImage(state) {
    return state.frontImage;
  },
  sideImage(state) {
    return state.sideImage;
  },
  backImage(state) {
    return state.backImage;
  },
  getted_detalles(state) {
    return state.getted_detalles;
  },
  accesos_detalles(state) {
    return state.accesos_detalles;
  },
  accesos_list(state) {
    return state.accesos_list;
  },
  accesos_total(state) {
    return state.accesos_total;
  },
  loading_accesos(state) {
    return state.loading_accesos;
  },
  sending_revoke(state) {
    return state.sending_revoke;
  },
  revoke_sent(state) {
    return state.revoke_sent;
  },
  revoke_alert(state) {
    return state.alert;
  },
  revoke_alertMessage(state) {
    return state.alertMessage;
  },
  revoke_alertType(state) {
    return state.alertType;
  },
};

const actions = {
  [FETCH_FACE_IMAGE](context, image) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.queryBlob(`accesos/colaborador_access_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(SET_FACE_IMAGE, buffer);
          resolve(data);
        })
        .catch(() => {
          context.commit(FETCHED_ACCESO_DETALLES);
        });
    });
  },
  [FETCH_CREDENTIAL_IMAGE](context, image) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.queryBlob(`accesos/colaborador_access_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(SET_CREDENTIAL_IMAGE, buffer);
          resolve(data);
        })
        .catch(() => {
          context.commit(FETCHED_ACCESO_DETALLES);
        });
    });
  },
  [FETCH_BACK_CREDENTIAL_IMAGE](context, image) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.queryBlob(`accesos/colaborador_access_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(SET_BACK_CREDENTIAL_IMAGE, buffer);
          resolve(data);
        })
        .catch(() => {
          context.commit(FETCHED_ACCESO_DETALLES);
        });
    });
  },
  [FETCH_FRONT_IMAGE](context, image) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.queryBlob(`accesos/colaborador_access_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(SET_FRONT_IMAGE, buffer);
          resolve(data);
        })
        .catch(() => {
          context.commit(FETCHED_ACCESO_DETALLES);
        });
    });
  },
  [FETCH_SIDE_IMAGE](context, image) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.queryBlob(`accesos/colaborador_access_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(SET_SIDE_IMAGE, buffer);
          resolve(data);
        })
        .catch(() => {
          context.commit(FETCHED_ACCESO_DETALLES);
        });
    });
  },
  [FETCH_BACK_IMAGE](context, image) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESO_DETALLES);
      ApiService.setHeader();
      ApiService.queryBlob(`accesos/colaborador_access_image/${image}`)
        .then(({ data }) => {
          const buffer = Buffer.from(data, 'base64').toString('base64');
          context.commit(SET_BACK_IMAGE, buffer);
          resolve(data);
        })
        .catch(() => {
          context.commit(FETCHED_ACCESO_DETALLES);
        });
    });
  },
  [FETCH_ACCESOS](context, data) {
    return new Promise((resolve) => {
      context.commit(FETCHING_ACCESOS);
      ApiService.setHeader();
      ApiService.post('accesos/collaborator_access_historic_list', data)
        .then(({ data }) => {
          context.commit(SET_ACCESOS, data);
          context.commit(FETCHED_ACCESOS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_ACCESOS);
        });
    });
  },
  [CLEAR_ACCESOS_ACTION](context) {
    context.commit(CLEAR_ACCESOS);
  },
};

const mutations = {
  [FETCHING_ACCESO_DETALLES](state) {
    state.getted_detalles = false;
  },
  [CLEAR_IMAGES](state) {
    state.frontImage = null;
    state.sideImage = null;
    state.backImage = null;
    state.faceImage = null;
    state.credentialImage = null;
    state.backCredentialImage = null;
  },
  [SET_FACE_IMAGE](state, data) {
    state.faceImage = data;
  },
  [SET_CREDENTIAL_IMAGE](state, data) {
    state.credentialImage = data;
  },
  [SET_BACK_CREDENTIAL_IMAGE](state, data) {
    state.backCredentialImage = data;
  },
  [SET_FRONT_IMAGE](state, data) {
    state.frontImage = data;
  },
  [SET_BACK_IMAGE](state, data) {
    state.backImage = data;
  },
  [SET_SIDE_IMAGE](state, data) {
    state.sideImage = data;
  },
  [FETCHED_ACCESO_DETALLES](state) {
    state.getted_detalles = true;
  },
  [CLEAR_ACCESOS_DETALLES](state) {
    state.accesos_detalles = [];
    state.getted_detalles = false;
  },
  [SET_ACCESO_DETALLES](state, data) {
    state.accesos_detalles = data.detalle;
  },
  [SET_ACCESOS](state, data) {
    state.accesos_list = data.accesos_colaboradores;
    state.accesos_total = data.total;
  },
  [CLEAR_ACCESOS](state) {
    state.accesos_list = [];
    state.accesos_total = 0;
  },
  [FETCHING_ACCESOS](state) {
    state.loading_accesos = true;
  },
  [FETCHED_ACCESOS](state) {
    state.loading_accesos = false;
  },
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
